const Redirect = () => import('@/views/utils/Redirect.vue')

export default [
    
    {
        path: '/ia/agent',
        component: Redirect,
        name: 'redirect.ai.agnet',
        beforeEnter: (to, from, next) => {
            window.location.href = `/v3/agentes`
        }
    },
]